import { HttpParams } from '../types';

export const applyPathParams = (url: string) => (
  pathParams: HttpParams = {}) => Object.entries(pathParams).reduce(
  (currentUrl, [key, value]) => currentUrl.replace(`{{${key}}}`, value),
  url,
);
